export const FLOAT_BUTTON_CONFIG = {
  variant: 'extended',
  'aria-label': 'check-in',
}
export const FLOAT_BUTTON_BADGE_CONFIG = {
  color: 'primary',
  anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
}
export const FLOAT_BUTTON_BOUNDS = {
  top: 100 - window.innerHeight,
  left: 100 - window.innerWidth,
  right: 0,
  bottom: 0,
}

export const FLOAT_BUTTON_STORAGE_CONFIG = {
  checkInPosition: 'checkInPosition',
}

export const FLOAT_BUTTON_BADGE_COUNTER_MAX = 999

export const FLOAT_BUTTON_DRAG_PRECISION = 1

export const NEW_CHECKIN_STATUSES = {
  SUCCESS: 'success',
  FAIL: 'fail',
  VALID_CHECK_IN: 'validCheckin',
  VALID_CHECK_IN_WITH_ALERTS: 'validCheckinWithAlerts',
  INVALID_CHECK_IN: 'inValidCheckin',
  DEFAULT_NO_CHECKIN: 'defaultNoCheckin',
}
